import { put, select, takeLatest } from 'redux-saga/effects'
import { IServiceConfig } from '../../configurations/store/configurations.types'
import { ITripInformationState } from '../store/tripInformation.types'
import { getTripInformationSelector } from '../selectors'
import { getTripInformationOptionsSelector } from '../../options/selectors/tripInformationOptions.selector'
import { IDispositionOption, ITripInformationOptionsState } from '../../options/store/options.types'
import { TripInformationConstants } from '../store/tripInformation.constants'
import {
  setCrewDisposition,
  setPatientEvaluation,
  setRefusalReleaseReason,
  setTransportDisposition,
  setUnitDisposition,
} from '../store/tripInformation.actions'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setDispositionDefaults() {
  const serviceConfig: IServiceConfig = yield select(getServiceConfigSelector)
  const { PR_NEMSIS35_DISPOSITION } = serviceConfig
  const tripInformationState: ITripInformationState = yield select(getTripInformationSelector)
  const { disposition } = tripInformationState
  const tripInformationOptions: ITripInformationOptionsState = yield select(getTripInformationOptionsSelector)
  const {
    dispositionOptions,
    unitDispositionOptions,
    patientEvaluationOptions,
    crewDispositionOptions,
    transportDispositionOptions,
    refusalReleaseReasonOptions,
  } = tripInformationOptions
  try {
    if (PR_NEMSIS35_DISPOSITION === 1) {
      if (disposition) {
        const dispositionOption: IDispositionOption | undefined = dispositionOptions.find(
          (option) => option.id === disposition.id
        )
        if (dispositionOption) {
          const defaultUnitDisposition = unitDispositionOptions?.find(
            (option) => option.id === dispositionOption.nemsis3_unit_dispo
          )
          const defaultPatientEvaluation = patientEvaluationOptions?.find(
            (option) => option.id === dispositionOption.nemsis3_pt_eval
          )
          const defaultCrewDisposition = crewDispositionOptions?.find(
            (option) => option.id === dispositionOption.nemsis3_crew_dispo
          )
          const defaultTransportDisposition = transportDispositionOptions?.find(
            (option) => option.id === dispositionOption.nemsis3_transport_dispo
          )
          const defaultRefusalReleaseReason = refusalReleaseReasonOptions?.find(
            (option) => option.id === dispositionOption.nemsis3_release_reason
          )
          yield put(setUnitDisposition(defaultUnitDisposition || null))
          yield put(setPatientEvaluation(defaultPatientEvaluation || null))
          yield put(setCrewDisposition(defaultCrewDisposition || null))
          yield put(setTransportDisposition(defaultTransportDisposition || null))
          if (defaultRefusalReleaseReason) yield put(setRefusalReleaseReason([defaultRefusalReleaseReason]))
          else yield put(setRefusalReleaseReason([]))
        } else {
          clearDispositionData()
        }
      } else {
        clearDispositionData()
      }
    } else {
      clearDispositionData()
    }
  } catch (e) {
    yield put(throwPcrException(`setDispositionDefaults() error: ${e}`))
  }
}

function* clearDispositionData() {
  yield put(setUnitDisposition(null))
  yield put(setPatientEvaluation(null))
  yield put(setCrewDisposition(null))
  yield put(setTransportDisposition(null))
  yield put(setRefusalReleaseReason([]))
}

export function* setDispositionDefaultsSaga() {
  yield takeLatest([TripInformationConstants.SET_DISPOSITION], performWithMutexHOG, setDispositionDefaults)
}
